module.exports = __webpack_public_path__ + "img/DNARepair-OVCA_10X_TPCP.d13d7490.png";